PJQ.logging = {
	LoggingActions: {
		GLOBAL_GET_SESSION: 'GLOBAL_GET_SESSION',
		AUTH_SIGN_IN: 'AUTH_SIGN_IN',
		AUTH_SIGN_UP: 'AUTH_SIGN_UP',
		AUTH_RESET_PASSWORD: 'AUTH_RESET_PASSWORD',
		PJQPROFILE_GET_SCREENINGS: 'PJQPROFILE_GET_SCREENINGS',
		PJQPROFILE_GET_PREQUAL: 'PJQPROFILE_GET_PREQUAL',
		SEND_PREQUAL_UPDATE: 'SEND_PREQUAL_UPDATE',
		PJQPROQUALADMIN_GET_INVITE: 'PJQPROQUALADMIN_GET_INVITE',
		PJQPROQUALADMIN_GET_ITEM: 'PJQPROQUALADMIN_GET_ITEM',
		PJQPROQUALADMIN_GET_REQUEST: 'PJQPROQUALADMIN_GET_REQUEST',
		PJQPROQUALADMIN_GET_ITEM_COMMENTS: 'PJQPROQUALADMIN_GET_ITEM_COMMENTS',
		PREQUAL_EXPORT: 'PREQUAL_EXPORT',
		FILE_DOWNLOAD_FAILED: 'FILE_DOWNLOAD_FAILED',
		SCREENING_PAYMENT: 'SCREENING_PAYMENT',
		GET_NEW_CONTACT_AB: 'GET_NEW_CONTACT_AB',
		PAYMENT_ERROR: 'PAYMENT_ERROR',
		DELETE_PROJECT_CONTACTS_OR_GROUPS: 'DELETE_PROJECT_CONTACTS_OR_GROUPS',
		UPLOAD_RAW_FILES: 'UPLOAD_RAW_FILES',
		REPORT_CONTACT: 'REPORT_CONTACT'
	}
};

PJQ.logging.Debug = class {
	constructor(action, data, options = {}) {
		this.action = action;
		this.data = data;
		this.options = _.defaults(options, {
			isIncludeUrl: true,
			isSave: true,
			onSave: _.noop
		});
		if (this.options.isSave)
			this.save();
	}

	save() {
		if (PJQ.helpers.objectHelpers.refinedType(this.data) !== 'object') {
			this.data = {
				data: this.data
			}
		}
		if (this.options.isIncludeUrl) {
			this.data = _.defaults(this.data, {
				SESSION_URL: window.location.href
			});
		}
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'logging'
				},
				{
					endpoint: 'debug'
				}
			]),
			data: {
				auditAction: this.action,
				data: this.data
			}
		}).post().done(_.bind(function () {
			if (typeof this.options.onSave === 'function')
				this.options.onSave(this);
		}, this));
	}
};